<section class="history-tab">
    <app-data-table
        [tableConfig]="tableConfig"
        (sortEvent)="sortHandler($event)"
        (pageEvent)="pageHandler($event)"></app-data-table>
</section>
